"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const mui_1 = require("tss-react/mui");
const luxon_1 = require("luxon");
const react_redux_1 = require("react-redux");
const AlarmOn_1 = __importDefault(require("@mui/icons-material/AlarmOn"));
const scheduled_transactions_1 = require("companion-app-components/flux/scheduled-transactions");
const QMenu_1 = __importDefault(require("components/QMenu"));
const QCheckbox_1 = __importDefault(require("components/QCheckbox"));
const QTip_1 = __importDefault(require("components/QuickenControls/QTip"));
const utils_1 = require("data/accounts/utils");
const selectors_1 = require("data/transactions/selectors");
const utils_2 = require("data/transactions/utils");
const selectors_2 = require("data/datasetSharing/selectors");
const styles_1 = require("../styles");
const useStyles = (0, mui_1.makeStyles)()(styles_1.styles);
const SelectField = ({ attributes, forceStatic, callbacks, editable, SHOW_ALL, fieldActive, txn, currEditFieldName, isAccountNotSynced, isTypeGrossPaycheck, selected, onRowSelect, msgGrossPaycheck, focusField, }) => {
    var _a;
    const { classes, theme } = useStyles();
    const transactionsByAccountId = (0, react_redux_1.useSelector)((state) => (0, selectors_1.getTransactionsByAccountId)(state));
    const scheduledTransactionsById = (0, react_redux_1.useSelector)((state) => scheduled_transactions_1.scheduledTransactionsSelectors.getScheduledTransactions(state));
    const hasWriteAccess = (0, react_redux_1.useSelector)((state) => (0, selectors_2.hasDatasetWriteAccess)(state));
    const isTransferAccountPresent = (0, react_redux_1.useSelector)((state) => (0, selectors_1.isTransferWritableAccountAvailable)(state, txn));
    const hasEditAccess = hasWriteAccess && isTransferAccountPresent;
    const isC2REnabled = (0, utils_1.isC2REnabledAccount)(txn.accountId);
    const renderRecurringField = () => {
        const accountTransactions = transactionsByAccountId.get(txn.accountId);
        let qtipTitle = null;
        const recurringStatus = (0, utils_2.getTxnStateInfo)(txn);
        const nextInstance = accountTransactions &&
            (0, utils_2.nextScheduledInstanceAfterDate)(luxon_1.DateTime.now().toISODate(), accountTransactions, txn.stModelId);
        const isNext = nextInstance && nextInstance.id === txn.id;
        const isUpcoming = (0, utils_2.isNextScheduledInstance)(txn, scheduledTransactionsById);
        let menuOptions = isUpcoming ?
            [
                { label: 'Enter this reminder', value: 'ACCEPT' },
                { label: 'Ignore this reminder', value: 'SKIP' },
            ]
            :
                [
                    { label: 'Enter this and all previous overdue reminders for this Payee as Paid', value: 'ACCEPT' },
                    { label: 'Ignore this and all previous overdue reminders for this Payee', value: 'SKIP' },
                ];
        let iconClass = '';
        switch (recurringStatus.status) {
            case 'DUE':
                qtipTitle = 'This reminder is due';
                iconClass = 'due';
                break;
            case 'OVERDUE':
                qtipTitle = 'This reminder is overdue';
                iconClass = 'overdue';
                break;
            default:
                if (isNext) {
                    qtipTitle = 'This will be the next instance that becomes due';
                }
                else {
                    qtipTitle = 'This reminder is not yet due';
                    iconClass = 'notdue';
                    menuOptions = null;
                }
                break;
        }
        // if this scheduled instance contains transfers to unsynced accounts, then do not allow the user to act
        if ((0, utils_2.transactionEditsNotAllowed)(txn)) {
            qtipTitle = 'This scheduled instance is a billpay transaction, or contains a transfer to an unsynced account ' +
                'or account that does not support transactions.' +
                ' You can only edit or act upon it from the desktop application';
            menuOptions = null;
        }
        else if (isTypeGrossPaycheck) {
            qtipTitle = msgGrossPaycheck;
            menuOptions = null;
        }
        const customTrigger = (<AlarmOn_1.default className={classes[iconClass]}/>);
        if (menuOptions) {
            return (<QMenu_1.default customTrigger={customTrigger} name={`${txn.id}-recurring`} title={qtipTitle} 
            // @ts-expect-error: Type '"mediumNoPadding"' is not assignable
            menuIconButtonSize="mediumNoPadding" autoFocus={fieldActive} options={menuOptions} onChange={(val) => { var _a; return (_a = callbacks.actOnScheduledTxn) === null || _a === void 0 ? void 0 : _a.call(callbacks, txn, val); }} 
            // @ts-expect-error: null is not assignable to type
            buttonRef={fieldActive ? (input) => {
                    focusField.current = input; // eslint-disable-line
                } : null}/>);
        }
        return (
        // @ts-expect-error: missing props
        <QTip_1.default title={qtipTitle} wrapId={`${txn.id}-recurring`}>
        {customTrigger}
      </QTip_1.default>);
    };
    return (<styles_1.RegListItem {...attributes} tabIndex={null} onClick={null} className={classes.iconButtonColumn}>
      {(0, utils_2.isUnacceptedScheduledTxn)(txn) && renderRecurringField()}
      {!(0, utils_2.isUnacceptedScheduledTxn)(txn) && SHOW_ALL &&
            <QCheckbox_1.default 
            // @ts-expect-error: Property 'register' does not exist on type 'Components<BaseTheme>'.
            size={(_a = theme.components) === null || _a === void 0 ? void 0 : _a.register.checkboxSize} color="primary" inputProps={{ 'aria-label': 'Select or Unselect' }} autoFocus={editable && currEditFieldName === 'select'} disabled={!hasEditAccess || (isAccountNotSynced && !editable) || forceStatic || ((0, utils_2.isBankOwnedPending)(txn) && isC2REnabled) || isTypeGrossPaycheck} checked={selected} inputRef={editable && !forceStatic && currEditFieldName === 'select' ?
                    (input) => {
                        focusField.current = input; // eslint-disable-line
                    } : null} onClick={() => onRowSelect(txn, !selected)}/>}
    </styles_1.RegListItem>);
};
exports.default = SelectField;
